export default __webpack_public_path__ + "static/media/Right_Arrow.ccc02a1d.svg";